import { createSlice } from "@reduxjs/toolkit";

export const initialServiceLocalState = {
  vehicle_id: null,
  date: null,
  title: "",
  cost: null,
  is_paid: false,
};

export const settingSlice = createSlice({
  name: "setting",
  initialState: {
    surveySettingResponse: {},
    isSurveySettingResponse: false,
    leadEmailCommunication: null,
    isUpdateLeadEmailCommunicationResponse: false,
    defaultSurveyRooms: null,
    defaultSurveyRoomItems: null,
    updateSurveyRoomResponse: false,
    updateSurveyRoomItemResponse: false,
    deleteSurveyRoomItemResponse: false,
  },

  reducers: {
    getSurveySetting: (state) => {},
    setSurveySettingResponse: (state, { payload }) => {
      state.surveySettingResponse = payload;
    },

    updateSurveySettingAction: (state, { payload }) => {},
    updatedSurveySettingResponse: (state, { payload }) => {
      state.isSurveySettingResponse = payload;
    },

    getCommunincationAction: (state) => {},
    setCommunicationResponse: (state, { payload }) => {
      state.leadEmailCommunication = payload;
    },

    updateCommunicationAction: (state, { payload }) => {},
    setUpdateCommunicationResponse: (state, { payload }) => {
      state.isUpdateLeadEmailCommunicationResponse = payload;
    },

    getDefaultSurveyRoomAction: (state) => {},
    setDefaultSurveyRoomResponse: (state, { payload }) => {
      state.defaultSurveyRooms = payload;
    },

    getDefaultSurveyRooomItemAction: (state, { payload }) => {},
    setDefaultSurveyRoomItemResponse: (state, { payload }) => {
      state.defaultSurveyRoomItems = payload;
    },

    updateDefaultSurveyRoomAction: (state, { payload }) => {},
    setUpdateDefaultSurveyRoomResponse: (state, { payload }) => {
      state.updateSurveyRoomResponse = payload;
    },

    updateDefaultSurveyRoomItemAction: (state, { payload }) => {},
    setUpdateDefaultSurveyRoomItemResponse: (state, { payload }) => {
      state.updateSurveyRoomItemResponse = payload;
    },

    deleteDefaultSurveyRoomItemAction: (state, payload) => {},
    setDeleteDfaultSurveyRoomItemResponse: (state, { payload }) => {
      state.deleteSurveyRoomItemResponse = payload;
    },
  },
});

const {
  getSurveySetting,
  setSurveySettingResponse,
  updateSurveySettingAction,
  updatedSurveySettingResponse,
  getCommunincationAction,
  setCommunicationResponse,
  updateCommunicationAction,
  setUpdateCommunicationResponse,
  getDefaultSurveyRoomAction,
  setDefaultSurveyRoomResponse,
  getDefaultSurveyRooomItemAction,
  setDefaultSurveyRoomItemResponse,
  updateDefaultSurveyRoomAction,
  setUpdateDefaultSurveyRoomResponse,
  updateDefaultSurveyRoomItemAction,
  setUpdateDefaultSurveyRoomItemResponse,
  deleteDefaultSurveyRoomItemAction,
  setDeleteDfaultSurveyRoomItemResponse,
} = settingSlice.actions;

export {
  getSurveySetting,
  setSurveySettingResponse,
  updateSurveySettingAction,
  updatedSurveySettingResponse,
  getCommunincationAction,
  setCommunicationResponse,
  updateCommunicationAction,
  setUpdateCommunicationResponse,
  getDefaultSurveyRoomAction,
  setDefaultSurveyRoomResponse,
  getDefaultSurveyRooomItemAction,
  setDefaultSurveyRoomItemResponse,
  updateDefaultSurveyRoomAction,
  setUpdateDefaultSurveyRoomResponse,
  updateDefaultSurveyRoomItemAction,
  setUpdateDefaultSurveyRoomItemResponse,
  deleteDefaultSurveyRoomItemAction,
  setDeleteDfaultSurveyRoomItemResponse,
};

export default settingSlice.reducer;
